import { createStart, createCsrfMiddleware, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { lazySupabaseAuth } from "@/lib/lazy-supabase-auth";

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  // /lovable/* server routes (email webhooks, template previews) authenticate
  // themselves and must bypass app middleware.
  if (new URL(request.url).pathname.startsWith("/lovable/")) {
    return next();
  }
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Start installs this automatically when src/start.ts is absent; defining the
// file opts out, so re-add it explicitly to keep server functions protected
// from cross-site requests.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => ({
  // Same bearer-token attachment as the generated auth attacher, but the
  // Supabase client loads only when a session is already stored.
  functionMiddleware: [lazySupabaseAuth],
  requestMiddleware: [errorMiddleware, csrfMiddleware],
}));
